import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  LinearProgress,
  Typography,
} from "@mui/material";
import { ClaimsSelectionContent } from "components/claimSelection/ClaimsSelectionContent";
import { OneTimeSeatWarningDialog } from "components/OneTimeSeatWarningDialog";
import { hasOneTimeSeatChanges } from "data/hasOneTimeSeatChanges";
import { ServiceSummary, ServiceWithClaims, User } from "data/interfaces";
import { useState } from "react";

interface ActivateServicesDialogDialogProps {
  open: boolean;
  users: User[];
  services: ServiceSummary[];
  onClose: () => void;
  onActivateServices: (selectedServicesAndClaims: ServiceWithClaims[]) => void;
}

export default function ActivateServicesDialog({
  open,
  users,
  services,
  onClose,
  onActivateServices,
}: ActivateServicesDialogDialogProps) {
  const [selectedServicesWithClaims, setSelectedServicesWithClaims] = useState<
    ServiceWithClaims[]
  >([]);
  const [loading, setLoading] = useState(false);
  const [oneTimeSeatWarningOpen, setOneTimeSeatWarningOpen] = useState(false);

  const doActivate = () => {
    setLoading(true);
    onActivateServices(
      selectedServicesWithClaims.filter((s) => s.claims.length !== 0),
    );
  };

  const handleActivateClick = () => {
    if (hasOneTimeSeatChanges(services, [], selectedServicesWithClaims)) {
      setOneTimeSeatWarningOpen(true);
    } else {
      doActivate();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth={true}>
      {loading ? <LinearProgress></LinearProgress> : null}
      <DialogTitle>
        Activate services and roles
        <Typography sx={{ mt: 2 }}>{users.length} user(s) selected.</Typography>
        <Typography sx={{ fontWeight: "bold", mt: 2 }}>
          Available services
        </Typography>
      </DialogTitle>
      <DialogContent>
        <ClaimsSelectionContent
          services={services}
          selected={selectedServicesWithClaims}
          updateSelected={setSelectedServicesWithClaims}
          defaultSelected={[]}
          selectedUsersCount={users.length}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleActivateClick}>Activate</Button>
      </DialogActions>
      <OneTimeSeatWarningDialog
        open={oneTimeSeatWarningOpen}
        onClose={() => setOneTimeSeatWarningOpen(false)}
        onConfirm={() => {
          setOneTimeSeatWarningOpen(false);
          doActivate();
        }}
      />
    </Dialog>
  );
}
